import { render } from "./range.vue?vue&type=template&id=204e71ce&scoped=true"
import script from "./range.vue?vue&type=script&lang=js"
export * from "./range.vue?vue&type=script&lang=js"

import "./range.vue?vue&type=style&index=0&id=204e71ce&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204e71ce"]])

export default __exports__